<template>
    <div style="background-color: rgba(244, 245, 255, 0.8);" class="mt-4 border history-dashboard">
        <el-card shadow="hover" class="pr-1">
            <h4 class="mb-2 font-weight-bold">Lịch sử khách hàng của bạn</h4>
            <el-timeline>
                <template>
                    <div :key="index" class="scrollable"
                         v-for="([date, items], index) in Object.entries(groupedTimeline)">
                        <el-timeline-item placement="top">
                            <div class="text-center text-muted font-italic">Ngày {{ date }}</div>
                        </el-timeline-item>
                        <el-timeline-item v-for="(item, idx) in items" :key="`${index}-${idx}`" :color="item.status ? '#3f1889' : '' " placement="top" type="primary">
                            <div style="background-color: #FFFFFF;" class="p-2 rounded shadow mr-2">
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <el-tooltip :content="item.title" placement="top">
                                        <p class="truncate font-weight-bold mb-1">{{ item.title }}</p>
                                    </el-tooltip>
                                    <p class="font-weight-bold mb-1">{{ item.time_tao }}</p>
                                </div>
                                <p class="text-muted mb-0">{{ item.content }}</p>
                            </div>
                        </el-timeline-item>
                    </div>

                </template>
            </el-timeline>
            <div v-if="timelineItems.length === 0">Chưa có dữ liệu</div>
        </el-card>
    </div>
</template>

<script>
import {DASHBOARD_HISTORY_BY_USER} from "../../../../core/services/store/dashboard.module";
import {mapGetters, mapState} from "vuex";
import echo from '@/echo';

export default {
    name: "HistoryDashboard",
    props: {},
    data() {
        return {
            timelineItems: [],

        };
    },
    computed: {
        groupedTimeline() {
            return this.timelineItems.reduce((acc, item) => {
                if (!acc[item.date]) acc[item.date] = [];
                acc[item.date].push(item);
                return acc;
            }, {});
        },
        ...mapState({
            errors: state => state.auth.errors
        }),
        ...mapGetters(['currentUser', 'keyAccount', 'targetPersonal'])
    },
    methods: {
        async getHistoryByUser() {
            let response = await this.$store.dispatch(DASHBOARD_HISTORY_BY_USER, {is_special: 1});
            let res = response.data ?? [];
            res = res.map((item) => {
                let title = this.categorizeContent(item.content, item.name);
                return {
                    ...item,
                    title
                };
            });
            this.timelineItems = res;
        },

        categorizeContent(content, name) {
            const lowerContent = content.toLowerCase();
            if (lowerContent.includes("đóng tiền")) {
                return "KH: " + name + " đóng tiền";
            }
            if (lowerContent.includes("tạo mới data")) {
                return "Bạn vừa thêm 1 KH mới ";
            }

            if (lowerContent.includes("chuyển thành khách hàng tự do")) {
                return "KH: " + name + " trạng thái sang tự do";
            }

            if (lowerContent.includes("đặt lịch")) {
                return "KH: " + name + " đã có lịch tư vấn";
            }

            if (lowerContent.includes("tạo hợp đồng")) {
                return name + " được tạo Hợp đồng";
            }

            if (lowerContent.includes("xác nhận lên tư vấn")) {
                return "KH: " + name + " xác nhận";
            }
            if (lowerContent.includes("chuyển từ TVV")) {
                return "KH: " + name + " chuyển Tư Vấn Viên";
            }
            if (lowerContent.includes("Khách hàng đã up level từ")) {
                return "Cập nhật trạng thái KH ";
            }

            if (lowerContent.includes("được thêm khóa học")) {
                return "Thêm khóa học cho KH ";
            }
            if (lowerContent.includes(" bị xóa khóa học")) {
                return "Xóa khóa học của hợp đồng ";
            }

            if (lowerContent.includes("sửa giá gốc khóa học")) {
                return "Sửa giá khóa học cho KH ";
            }

            if (lowerContent.includes("bị xóa mã khuyến mại ")) {
                return "Xóa mã khuyến mại hợp đồng ";
            }
            if (lowerContent.includes(" vừa được thêm mã khuyến mại")) {
                return "Mã khuyến mại được thêm vào Hợp đồng ";
            }
            if (lowerContent.includes("khách hàng được cập nhật tình trạng ")) {
                return "Chăm sóc KH: " + name + " cập nhật tình trạng ";
            }
            return "Khác";
        },
    },
    mounted() {
        this.$echo.channel(`history.${this.currentUser.id}`).listen('HistoryChannel', (payload) => {
            console.log(payload);
            payload.title = this.categorizeContent(payload.content, payload.name);
            payload.status = 'Mới';
            this.timelineItems.unshift(payload);
            this.$notify({
                title: payload.title,
                message: payload.content,
                position: 'bottom-right',
                duration: '10000'
            });
        });
        this.getHistoryByUser();
    },
    beforeDestroy() {
        this.$echo.leaveChannel(`history.${this.currentUser.id}`);
    }
};
</script>

<style>
#dashboard-leader .el-timeline-item__node--primary {
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25);
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(208, 208, 208, 1);
    color: rgba(255, 255, 255, 1);
    width: 25px;
    height: 25px;
    left: -7px;
    top: 31px;
}

#dashboard-leader .el-timeline-item__wrapper {
    position: relative;
    padding-left: 28px;
    top: -9px;
}

#dashboard-leader li.el-timeline-item {
    padding-bottom: 5px;
    padding-top: 5px;
}

.el-timeline {
    max-height: 400px;
    overflow-y: auto;
    padding-left: 10px;
}

#dashboard-leader .el-card {
    background-color: #ff000000;
    border: none;
    box-shadow: none;
}

#dashboard-leader .el-timeline {
    max-height: 400px;
    overflow-y: auto;
    padding-left: 10px;
}

#dashboard-leader .el-timeline-item__tail {
    height: 145px;
}

#dashboard-leader .el-timeline::-webkit-scrollbar {
    width: 2px; /* chiều rộng scrollbar */
}

#dashboard-leader .el-timeline::-webkit-scrollbar-track {
    background: #f1f1f1; /* màu nền track */
    border-radius: 4px;
}

#dashboard-leader .el-timeline::-webkit-scrollbar-thumb {
    background: #888; /* màu scrollbar */
    border-radius: 4px;
}

#dashboard-leader .el-timeline::-webkit-scrollbar-thumb:hover {
    background: #555; /* khi hover */
}

.truncate {
    width: 70%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
